import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "sort",
  "use": "sort-usage",
  "viewBox": "0 0 20 15",
  "content": "<symbol viewBox=\"0 0 20 15\" xmlns=\"http://www.w3.org/2000/svg\" id=\"sort\">\n<path d=\"M12 0H20V2H12V0ZM12 5.5H20V7.5H12V5.5ZM12 11H20V13H12V11ZM0 6.5C0 10.08 2.92 13 6.5 13H7V15L10 12L7 9V11H6.5C4.02 11 2 8.98 2 6.5C2 4.02 4.02 2 6.5 2H10V0H6.5C2.92 0 0 2.92 0 6.5Z\" fill=\"\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol